/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import PlayStage from './PlayStage';
import BrushStage from './BrushStage';
import BrushSelector from './BrushSelector';
import SamplePlayer from './SamplePlayer';
import SoundBanks from './SoundBanks';
import ErrorBoundary from './ErrorBoundary';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStop, faTrashCan } from '@fortawesome/free-solid-svg-icons';

import './SoundCanvas.css';

/* eslint-disable spaced-comment */
/* eslint-disable multiline-comment-style */

function SoundCanvas () {
  const brushSelectorRef = useRef();
  const samplePlayerRef = useRef();
  const shapesLayerRef = useRef();

  const playStageContainerRef = useRef();
  const brushStageContainerRef = useRef();

  const [selectedFormIndex, setSelectedFormIndex] = useState(0);
  const [selectedTextureIndex, setSelectedTextureIndex] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [selectedSoundBankIndex, setSelectedSoundBankIndex] = useState(0);
  const [resetTrigger, setResetTrigger] = useState(0);

  const [soundBank] = useState(0);
  const [tempo, setTempo] = useState(120);
  //const padding = { left: 20, top: 20, right: 20, bottom: 20 };
  const playStageRatio = 16 / 6;

  const sceneBaseWidth = 800;
  const sceneBaseHeight = 600;
  const sceneMaxWidth = 1024;
  //const sceneMaxHeight = 768;

  const [playStageDimensions, setPlayStageDimensions] = useState({ width: 0, height: 0 / playStageRatio, scale: 1 });
  // eslint-disable-next-line no-unused-vars
  const [playStagePosition, setPlayStagePosition] = useState({ x: 0, y: 0 });
  const [brushStageDimensions, setBrushStageDimensions] = useState({ width: 0, height: 0 / playStageRatio, scale: 1 });

  //const [setFrameRate] = useState(30);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [playStageDimensions]);

  const handleResize = () => {
    const playStageBoundingRect = playStageContainerRef.current.getBoundingClientRect();
    const brushStageBoundingRect = brushStageContainerRef.current.getBoundingClientRect();

    // Odd size can cause blurry picture due to subpixel rendering
    if (playStageBoundingRect.width % 2 !== 0) playStageBoundingRect.width--;
    if (playStageBoundingRect.height % 2 !== 0) playStageBoundingRect.height--;

    const scaleX = Math.min(playStageBoundingRect.width, sceneMaxWidth) / sceneBaseWidth;
    const scale = { x: scaleX, y: scaleX };

    setPlayStageDimensions({
      width: playStageBoundingRect.width,
      height: playStageBoundingRect.width / playStageRatio,
      scale
    });

    const x = (playStageBoundingRect.width - sceneBaseWidth * scaleX) * 0.5;
    const y = (playStageBoundingRect.height - sceneBaseHeight * scaleX) * 0.5;

    setPlayStagePosition({
      x,
      y
    });

    setBrushStageDimensions({
      width: brushStageBoundingRect.width,
      height: playStageBoundingRect.width / playStageRatio
    });
  };

  useEffect(() => {
    handleResize();
  }, []);

  const handleBrushChange = (texture, form) => {
    setSelectedTextureIndex(texture.selectedTextureIndex);
    setSelectedFormIndex(form.selectedFormIndex);
  };

  const onTextureSelect = (textureIdx) => {
    //brushSelectorRef.current.dispatch({ type: 'select', payload: textureIdx });
    setSelectedTextureIndex(textureIdx);
  };

  // function downloadURI (uri, name) {
  //   const link = document.createElement('a');
  //   link.download = name;
  //   link.href = uri;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }

  // const handleImageSave = () => {
  //   const layer = shapesLayerRef.current;

  //   if (!layer) {
  //     console.warn('Layer not found');
  //     return;
  //   }

  //   const url = layer.getCanvas().toDataURL();
  //   downloadURI(url, 'digiorc.png');

  //   console.log('save image');
  // };

  const handleReset = () => {
    setResetTrigger((resetTrigger) => resetTrigger + 1); //
  };

  const handleStopMonitor = () => {
    samplePlayerRef.current && (samplePlayerRef.current.stopMonitor());
  };

  useEffect(() => {
    //const frameRate = tempo * playStageWidth / 1000;
    //setFrameRate(frameRate);
  }, [tempo]);

  // eslint-disable-next-line no-unused-vars
  const handleTempoChange = (e) => {
    setTempo(Number(e.target.value));
  };

  // eslint-disable-next-line no-unused-vars
  const handleSoundBankChange = (idx) => {
    setSelectedSoundBankIndex(idx);
    samplePlayerRef.current && (samplePlayerRef.current.loadSoundBank(SoundBanks[idx]));
    //setSoundBank(i);
  };

  return (
    <div className="container-fluid align-items-center">
      <div className='row align-items-center my-2 d-flex justify-content-between'>
        <div className = 'col-md-auto col-1'>
          <button
            id = 'stopMonitor'
            className = 'btn btn-light btn-sm'
            onClick={handleStopMonitor}
            ><FontAwesomeIcon icon={faStop} />
          </button>
        </div>
        <div className = 'col-md-auto col-11'>
          <div className = 'row align-items-center flex-nowrap gx-1'>
            <div className = 'col-auto btn-sm canvas-text flex-nowrap'>
              <label
                className= 'p-3'>Sound Bank:
              </label>
            </div>
              <div className='btn-toolbar mx-2'>
                {SoundBanks.map((soundBank, i) => {
                  return (
                  // <div
                  //   key = {i}
                  //   className = 'col-1'
                  // >
                    <ToggleButton
                      className = 'btn-sm btn-light canvas-text mx-1'
                      key = {i}
                      type="checkbox"
                      checked = {selectedSoundBankIndex === i}
                      onClick={() => handleSoundBankChange(i)}
                      href="#"
                      >{i}
                    </ToggleButton>
                  // </div>
                  );
                })}
              </div>
          </div>
        </div>

        <div className = 'col-md-auto col-3'>
          <div className = 'form-inline align-items-center nowrap'>
            <div className = 'input-group bg-transparent flex-nowrap'>
              <label
                // htmlFor="durationInput"
                className='input-group-text bg-transparent border-0 flex-nowrap'
              >Dauer
              </label>
                <input
                  id="durationInput"
                  className="range"
                  type="range"
                  min="3"
                  max="180"
                  step="1"
                  value={tempo}
                  onChange={(e) => handleTempoChange(e)}
                >
                </input>
                <label
                  className='input-group-text time no-wrap bg-transparent border-0 flex-nowrap'> {tempo} s
                </label>
            </div>
          </div>
        </div>

        <div className = 'col-md-auto col-3'>
          <button
            id = 'reset'
            className = 'btn btn-dark btn-sm'
            onClick={handleReset}
            ><FontAwesomeIcon icon={faTrashCan} />
          </button>
        </div>
                {/* <div className = 'col-sm-auto'>
          <button
            id = 'saveImageButton'
            className = 'btn btn-dark'
            onClick={handleImageSave}
            >Save Image
          </button>
        </div> */}
      </div>

      {/* </div> */}

      <div className='row max-width-container'>
        <div className='col-1 p-0' ref={brushStageContainerRef}>
          <BrushSelector
            ref={brushSelectorRef}
            onChange={handleBrushChange}
          ></BrushSelector>
          <BrushStage
            //ref={brushRef}
            selectedFormIndex={selectedFormIndex}
            selectedTextureIndex={selectedTextureIndex}
            width={brushStageDimensions.width}
            height={brushStageDimensions.height}
            samplePlayerRef={samplePlayerRef}
            selectTexture={onTextureSelect}
          ></BrushStage>
        </div>

        <div className='col-11 p-0' ref={playStageContainerRef}>
          <PlayStage
            // x={playStagePosition.x}
            // y={playStagePosition.y}
            scale={playStageDimensions.scale}
            width={playStageDimensions.width}
            height={playStageDimensions.height}
            selectedFormIndex={selectedFormIndex}
            selectedTextureIndex={selectedTextureIndex}
            selectedSoundBankIndex={selectedSoundBankIndex}
            samplePlayerRef={samplePlayerRef}
            shapesLayerRef={shapesLayerRef}
            tempo={tempo}
            resetTrigger={resetTrigger}
          ></PlayStage>
          <ErrorBoundary>
            <SamplePlayer ref={samplePlayerRef} soundBank={soundBank} />
          </ErrorBoundary>
        </div>
      </div>

      <div className='container-fluid'>
        <div className='row mt-4'>
          <div className='col-md-12'>
            <div className="alert alert-primary" role="alert">
                <strong>Komponieren:</strong> Kombiniere Formen mit Farben auf dem Liniengitter, um deine graphische Partitur zu erstellen
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className="alert alert-success" role="alert">
              <strong>Abspielen:</strong> {'Drücke die'} <span className="badge bg-secondary">Leertaste</span> {'um deine Komposition abzuspielen.'}
            </div>
          </div>
        </div>

        <div className='row'>
          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Platzieren:</strong> {'Klicke eine Form an und platziere sie auf dem Liniengitter. Du kannst mit der'} <span className="badge bg-secondary">Maus</span> {'die Form auf dem Liniengitter durch ziehen genauer platzieren.'}
            </div>
          </div>

          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Form und Farbe:</strong> {'Wechsle zwischen den Formen mit den'} <span className="badge bg-secondary">Pfeiltasten</span> {'deiner Tastatur'} <span className="badge bg-secondary">←</span> <span className="badge bg-secondary">→</span>. Jede Farbe <span className="badge bg-secondary">↑</span> <span className="badge bg-secondary">↓</span> {'steht für einen anderen Klang aus der gewählten Sound Bank'}
            </div>
          </div>

          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Größe:</strong> {'Klicke auf eine Form und ziehe an einer Ecke, um die Größe zu verändern. Je größer die Form, desto lauter wird sie gespielt. Je länger die Form ist, desto länger erklingt sie. '}
            </div>
          </div>

          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Drehen:</strong> {'Klicke auf eine Form und dann ziehe am Ende des Strichs. So kannst du die Form in die gewünschte Position drehen.'}
            </div>
          </div>
        </div>

        <div className='row'>
          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Dauer:</strong> {'Verwende den Slider "Dauer", um die Länge deiner Komposition einzustellen.'}
            </div>
          </div>

          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Sound Bank:</strong> {'Wähle eine der fünf verschiedenen Klangsammlungen in der Sound Bank aus.'}
            </div>
          </div>

          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Liniengitter:</strong> {'Platziere Formen auf dem Liniengitter, wobei höhere Platzierungen zu höheren Tönen führen.'}
            </div>
          </div>

          <div className="col-md-3">
            <div className="alert alert-secondary fixed-height-alert " role="alert">
                <strong>Löschen:</strong> {'Klicke auf eine Form auf dem Liniengitter und drücke die "Entfernen"-Taste '}<span className="badge bg-secondary">Del/Entf</span>{', um sie zu löschen.'}
            </div>

        </div>
      </div>
      </div>
    </div>
  );
};

export default React.memo(SoundCanvas);
